import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stock",
  "use": "icon-stock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stock\">\n  <path d=\"M832 192H640V128c0-35.3-28.7-64-64-64H448c-35.3 0-64 28.7-64 64v64H192c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM448 128h128v64H448v-64z m320 704H256V256h128v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32h128v576z\" fill=\"currentColor\" p-id=\"3427\" />\n  <path d=\"M320 416h384v64H320zM320 544h384v64H320zM320 672h384v64H320z\" fill=\"currentColor\" p-id=\"3428\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/stock.svg
// module id = t+aG
// module chunks = 117